import React from "react";

import PageMetaData from "../../components/PageMetaData/PageMetaData.js";
import TitleMain from "../../components/TitleMain/TitleMain.js";

const Clock = () => {
  return (
    <>
      <PageMetaData title={"Clock | jBot"} />
      <TitleMain>Clock</TitleMain>
    </>
  );
};

export default Clock;
